import { css, cva } from '@/styled-system/css';

export const cardContainerRecipe = cva({
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '168px',
  },
  variants: {
    isHovered: {
      true: { backgroundColor: 'bg.accent.blue.soft' },
      false: {},
    },
    isStriped: {
      true: { backgroundColor: 'bg.action.neutral-fixed.hover' },
      false: { backgroundColor: 'bg.neutral' },
    },
  },
  compoundVariants: [
    {
      isHovered: true,
      isStriped: true,
      css: { backgroundColor: 'bg.accent.blue.soft' },
    },
    {
      isHovered: true,
      isStriped: false,
      css: { backgroundColor: 'bg.accent.blue.soft' },
    },
  ],
});

export const cardAddressStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  wordWrap: 'break-word',
  textAlign: 'left',
});

export const statusDotRecipe = cva({
  base: {
    height: '300',
    width: '300',
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: '100',
  },
  variants: {
    isActive: {
      true: { backgroundColor: 'purple.400' },
      false: { backgroundColor: 'icon.action.disabled' },
    },
  },
});

export const cardThumbnailStyles = css.raw({
  height: '168px',
  width: '168px',
  objectFit: 'cover',
  alignSelf: 'center',
});

export const cardThumbContainerStyles = css.raw({
  display: 'flex',
  height: '168px',
  width: '168px',
  background: 'bg.soft',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '200',
});
